<template>
  <basePopup ref="basePopup" :tips="tips">
    <div class="translate-list-item" :class="{ active: trans.value === lang }" v-for="trans in translateList"
      :key="trans.label" @click="confirmPopup(trans.value)">{{ trans.label }}</div>
  </basePopup>
</template>
<script>
import basePopup from '@/views/detailPage/components/Popup';
import { mapState } from 'vuex';

export default {
  name: 'TranlateControler',
  components: {
    [basePopup.name]: basePopup,
  },
  data() {
    return {
      tips: '请选择要翻译的目标语言',
      translateList: [
        {
          label: '默认',
          value: ''
        },
        {
          label: '中文（简体）',
          value: 'zh'
        },
        {
          label: '中文（繁体）',
          value: 't'
        },
        {
          label: 'English',
          value: 'en'
        },
      ]
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
    }),
  },
  methods: {
    _showPopup() {
      this.$refs.basePopup._showPopup();
    },
    confirmPopup(lang) {
      this.$store.commit('SET_DETAIL_PAGE_LANG', lang);
      this.$emit('translate', lang);
      this.$refs.basePopup._cancelPopup();
    }
  }

};
</script>
<style lang="less" scoped>
.translate-list-item {
  height: 48px;
  line-height: 48px;
  font-size: 16px;

  &.active {
    color: #0A5AFF
  }
}
</style>
